module.exports = __webpack_public_path__ + "static/media/6.4fab09a1.jpg";